export default __webpack_public_path__ + "static/media/viber_image_2022-05-14_12-20-11-861.c49ce0f6.jpg";